import React from "react";

import { GoChevronRight } from "react-icons/go";
import PlayerIgn from "./playerCardItems/PlayerIgn";
import PlayerOverlayButton from "./playerCardItems/PlayerOverlayButton";
import PlayerPhoto from "./playerCardItems/PlayerPhoto";
import PlayerSocials from "./playerCardItems/PlayerSocials";
import PlayerTags from "./playerCardItems/PlayerTags";
export default function PlayerCard({ player, loadProfile, position }) {
  if (position % 2 === 0) {
    return (
      <>
        <div className="  player-card2  my-3 d-flex flex-row  gap-0 gap-md-4 p-0 position-relative">
          <PlayerOverlayButton loadProfile={loadProfile} ign={player.ign} />
          {/* photo */}
          <PlayerPhoto photo={player.photo} />
          {/* details */}
          <div
            className="py-3 text-center flex-grow-1 text-md-start d-flex flex-column justify-content-center align-stretch-items  align-content-stretch px-2
    "
          >
            <div className="my-3">
              <PlayerIgn ign={player.ign} />

              <h3
                className="py-1  display-6 fs-4 fw-light "
                style={{ color: "#222" }}
              >
                {player.name}
              </h3>
              <PlayerSocials socials={player.socials} position={position} />
              {/* <PlayerTags tags={player.tags} /> */}
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="player-card2  my-3  d-flex   gap-0 gap-md-4 flex-row p-0 position-relative">
          <PlayerOverlayButton loadProfile={loadProfile} ign={player.ign} />

          {/* details */}
          <div
            className="py-3 text-center flex-grow-1 text-md-end d-flex flex-column justify-content-center align-stretch-items  align-content-stretch px-2
    "
          >
            <div className="my-3">
              <PlayerIgn ign={player.ign} />

              <h3
                className="py-1  display-6 fs-4 fw-light "
                style={{ color: "#222" }}
              >
                {player.name}
              </h3>
              <PlayerSocials socials={player.socials} position={position} />
              {/* <PlayerTags tags={player.tags} /> */}
            </div>
          </div>
          {/* photo */}
          <PlayerPhoto photo={player.photo} />
        </div>
      </>
    );
  }
}
